export enum EmploymentType {
  w2 = 'W2',
  ten99 = '1099'
}